import { render, staticRenderFns } from "./ClassListFilters.vue?vue&type=template&id=3aee781a&"
import script from "./ClassListFilters.vue?vue&type=script&lang=js&"
export * from "./ClassListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports